import { EncodeObject, GeneratedType } from '@cosmjs/proto-signing';
import { MsgConvertERC20 } from './ts-client/tx';

export const erc20Types: ReadonlyArray<[ string, GeneratedType ]> = [
  [ '/evmos.erc20.v1.MsgConvertERC20', MsgConvertERC20 ],
];

export interface MsgConvertERC20EncodeObject extends EncodeObject {
  readonly typeUrl: '/evmos.erc20.v1.MsgConvertERC20';
  readonly value: Partial<MsgConvertERC20>;
}

export function isMsgConvertERC20EncodeObject(object: EncodeObject): object is MsgConvertERC20EncodeObject {
  return object.typeUrl === '/evmos.erc20.v1.MsgConvertERC20';
}







